module.exports = __webpack_public_path__ + "img/hr-red-pita-01.a2b2cc80.png";